<template>
    <button type="button" @click="onHandleShowFilter" :class="`btn btn-${sizeBtn} btn-info`">
        <i :class="`fa fa-chevron-${isActiveFilter ? 'up' : 'down'}`" aria-hidden="true"></i>
    </button>
</template>

<script>
export default {
    name: 'ButtonActiveFilter',
    props: {
        active: {
            type: Boolean,
            default: () => true
        },
        smallCol: {
            type: Number,
            default: () => 0
        },
        largeCol: {
            type: Number,
            default: () => 0
        },
        sizeBtn: {
            type: String,
            default: () => 'md'
        }
    },
    data() {
        return {
            isActiveFilter: this.active,
            calcSmall: `calc(100vh - ${this.smallCol}px)`
        };
    },
    watch: {
        active(val) {
            this.isActiveFilter = val;
        }
    },
    methods: {
        onHandleShowFilter() {
            this.isActiveFilter = !this.isActiveFilter;
            this.tableHeight = this.isActiveFilter ? this.calcSmall : `${this.largeCol}vh`;
            this.$emit('update:active', this.isActiveFilter);
            this.$emit('sizeHeight', this.tableHeight);
        }
    },
    mounted() {
        this.$emit('sizeHeight', this.calcSmall);
    }
};
</script>

<style lang="scss" scoped></style>
